// Date --------- Developer ----- Description ----------------------------
// 09 Feb 2012 SK		Add settings to hold token, userId and other required vars
//						Pass token and userId to the server
//						Consolidate init code
//						Remove dependence on HTML nodes as containers of data. Use DSC settings object instead
// 25 May 2012	SK		Fixes for compatability with IE
// 11 Jun 2012	SK		Add network error handling
// 08 Jul 2012	SK		Call uScope functions to start or join after successfully connected to DSC server
// 14 Apr 2014  RTE     added UserDscAvailability
// 03 Jun  2014 CB      Modifications to support IE10+ to handle change in default XML DOM object returned from AJAX request (selectNodes failed)
//                      See: http://stackoverflow.com/questions/17743534/need-to-work-around-selectsinglenode-in-ie10
// 18 May 2015  SK      Change name of IsIE so that it does not override the one in Spectrum.js.

//Not sure why this function is defined here and in Spectrum.js. Really there should be one. 
//Perhaps this is loaded sometimes without Spectrum.js? So try to reuse the one in Spectrum.js.
//If that is not loaded, have specific logic.
function IsIEDSC()
{
    if (IsIE && typeof (IsIE) === 'function')
        return IsIE();
    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent))       //detect IE < 11.0
        return true;
    if (/Trident.*rv[ :]*11\./.test(navigator.userAgent))   //detect IE 11
        return true;
}

var _conferenceTypes = 
{
    CASE: "Case",
    STUDY: "Study"
};
/**
 * Values for the DscAvailability column in the Users table. These are the status values that
 * are returned from GetDSCUser (which returns rows from the Users table)
 */
var UserDscAvailability = 
{
    /**
     * user is avaiable
     */
    "Available" : "0",
    /**
     * user is busy
     */
    "Busy" : "1",
    /**
     * user is offline
     */
    "Offline" : "2",
    /**
     * Conferencing not allowed, e.g. role doesn't permit it, or running in eSM (which doesn't support conferencing)
     */
    "NotAllowed" : "4"
};
var _participant =
{
	ptName: "",
	ptUserId : 0,
	confName: "Dummy",
	confId : 0,
	confPwd: "",
	confToken: "",
	createConf: false,
	confManagerDivId : "",
	isLeader: false,
	vilDivId : "",
    conferenceType: _conferenceTypes.CASE,             //Case, Study
    conferenceTopLevelPrimaryKey: ""    //Primary Key for the conference table
};

function resetParticipant(resetAll) 
{
	if(resetAll)
	{
		_participant.ptName = "";
		_participant.ptUserId = 0;
		_participant.confName = "Dummy";
		_participant.confId = 0;
		_participant.confPwd = "";
		_participant.confToken = "";
		_participant.createConf = false;
		_participant.confManagerDivId = "";
		_participant.isLeader = false;
		_participant.vilDivId = "";
        _participant.conferenceType = _conferenceTypes.CASE;
        _participant.conferenceTopLevelPrimaryKey = "";
        
	}
	g_dscClient.resetDSCConnection();
}

function dscMessageRouter(respType, dscRoot)
{
	switch (respType) 
	{
		case "New Participant Response":
			if (_participant.createConf)
				createConference();
			else
				joinConference();
			break;
		case "New Conference Response":
			updateParticipantList(null);
			break;
		case "Join Conference Response":
			followConference();
			updateParticipantList(null);
			break;
		case "Leave Conference Response":
		case "Close Conference Response":
			cleanup();
			break;
		case "Conference Closed":
			confClosed();
			cleanup();
			break;
		case "New Leader":
            //if this user is the new leader
			if (dscRoot.getElementsByTagName("Participant")[0].attributes.getNamedItem("Name").value === _participant.ptName)			
            {
				leadConference();
            }
			else
            {
				followConference();
            }
		// fallthrough intentional?
		case "Add Participant":
			updateParticipantList(null);
			break;        
		case "Remove Participant":
            var name = dscRoot.getElementsByTagName("Participant")[0].attributes.getNamedItem("Name").value;
            if (name !== _participant.ptName) {
                dscAddLineToChat(name, "Left conference.");
            }
			updateParticipantList(null);
			break;
		case "List Participants Response":
			updateParticipantList(dscRoot);
			break;
		case "Assign Leadership Response":
			followConference();
			break;
		case "Participant Data Changed":
			updateParticipantList(dscRoot);
			break;
		case "Update Data":
			updateUserMsgList(dscRoot);
			break;
	}
}

function dscErrorHandlerFunc(errType, respType, dscRoot)
{
	if (errType === _dscErrorTypes.confNetError)
	{
		if(_participant.ptName !== "")				//abort errors happen when resetDSCConnection is called as part of reset. This forces us to ignore such spurious errors
		{
            var msg = "Lost connection to conferencing server. Closing conference.";
            if ('undefined' === typeof $.pnotify) {
                alert(msg);
            }
            else {
                $.pnotify(msg);
            }
			confClosed();
			cleanup();
			dscConsoleLog("Network error detected: Exiting conference");
		}
	}
	else
	{
		var errorDescription = getXMLNodeText(dscRoot, "Description");
		dscConsoleLog("Error: " + respType + " Failed. Reason: " + errorDescription);
	}
}

function cleanup()
{
	resetParticipant(true);
	resetParticipantList();
	resetConfControl();
}

/************
Conference management routines
************/

function initParticipant(dscSettings) 
{
	_participant.ptName = dscSettings.fullName;
	_participant.ptUserId = dscSettings.userId;
	_participant.confName = dscSettings.dscName;
	_participant.confId = dscSettings.dscId;
	_participant.confToken = dscSettings.authToken;
	_participant.confManagerDivId = dscSettings.confManagerDivId;
	_participant.vilDivId = dscSettings.vilDivId;
    _participant.conferenceType = dscSettings.conferenceType;
    _participant.conferenceTopLevelPrimaryKey = dscSettings.conferenceTopLevelPrimaryKey;
    
	g_dscClient.addDSCMessageHandler(_dscMessageTypes.confManagementMessage, dscMessageRouter);
    //viewer takes care of image-related (attribute) messages

	g_dscClient.addDSCErrorHandler(dscErrorHandlerFunc);
	//Create User data node
	msgDoc = createXMLDocument("temp");

	nd = msgDoc.createElement("User"); 											//add User node
	nd.setAttribute("Name", _participant.ptName);
	nd.setAttribute("Token", _participant.confToken);
	nd.setAttribute("Id", _participant.ptUserId);
	g_dscClient.sendDSCMessage("New Participant", nd, _dscMessageTypes.confManagementMessage);
}

function createConference(dscSettings) 
{
	var resultPromise = {};
    if (_participant.ptName === "") 
	{
		_participant.createConf = true;
        initParticipant(dscSettings);
	}
	else 
	{
		//Create User data node
		msgDoc = createXMLDocument("temp");

		dataNd = msgDoc.createElement("Data"); 										//create Data node
		tempNd = msgDoc.createElement("Name"); 										//create Name node
		setXMLNodeText(tempNd, _participant.confId);
		dataNd.appendChild(tempNd);

		tempNd = msgDoc.createElement("Id"); 										//Add conf id node
		setXMLNodeText(tempNd, _participant.confId);
		dataNd.appendChild(tempNd);

		tempNd = msgDoc.createElement("Attribute_List"); 							//add atribute list
		dataNd.appendChild(tempNd);
        
 		g_dscClient.sendDSCMessage("New Conference", dataNd, _dscMessageTypes.confManagementMessage);
		// set DSC availability to busy
		resultPromise = leica.pi.util.conference.setDscAvailability(UserDscAvailability.Busy);
	}
	$.when(resultPromise).done(function() {
        $('#confManager').data('initiator', true);
        $(document).trigger('VILJoinConference');    
    });

}

function joinConference(dscSettings) 
{
    var resultPromise = {};
    if (_participant.ptName === "") 
	{
		_participant.createConf = false;
		initParticipant(dscSettings);
	}
	else 
	{
		//Create User data node
		var msgDoc = createXMLDocument("temp");
		var dataNd = msgDoc.createElement("Data"); 									// create Data node
		var confNd = msgDoc.createElement("Conference"); 							// create Conference node
		confNd.setAttribute("Name", _participant.confId);
		confNd.setAttribute("Id", _participant.confId);
		dataNd.appendChild(confNd);

		g_dscClient.sendDSCMessage("Join Conference", dataNd, _dscMessageTypes.confManagementMessage);	
		resultPromise = leica.pi.util.conference.setDscAvailability(UserDscAvailability.Busy); // set DSC availability to busy
	}
    $.when(resultPromise).done(function() {
        $('#confManager').data('initiator', false);
        $(document).trigger('VILJoinConference');
    });
}

/**
 * Send message to leave conference, then return promise to set dsc availability
 * @returns {unresolved}
 */
function leaveConference() 
{
	var msgDoc = createXMLDocument("temp");
	var dataNd = msgDoc.createElement("Data");      //Create data node

    // TODO: Because sendDSCMessage is async, we cannot be sure that the call has completed before we return from this function
    // and since a caller of this function may reload the page after leaving the conference, the message may not be sent
    // Correct solution is for function sendDSCMessage to return a promise (for example, see leica.pi.util.conference.setDscAvailability)
    
    // if initiator, close conference; else if participant, leave conference
    if(_participant.createConf)
    	g_dscClient.sendDSCMessage("Close Conference", dataNd, _dscMessageTypes.confManagementMessage);
    else
		g_dscClient.sendDSCMessage("Leave Conference", dataNd, _dscMessageTypes.confManagementMessage);
    
	// set DSC availability to available
    $(document).trigger('VILLeaveConference'); // listener sets avaialbility UI elements 
    return leica.pi.util.conference.setDscAvailability(UserDscAvailability.Available);
}

function confClosed()
{
	$('#confManager').dialog('close'); // this call should result in the above leaveConference() being called
}

/*
Participant management functions
*/

function updateParticipantList(msgRoot) 
{
	if (msgRoot == null) 
	{
		//Create User data node
		msgDoc = createXMLDocument("temp");

		dataNd = msgDoc.createElement("Data"); 										//create Data node

		g_dscClient.sendDSCMessage("List Participants", dataNd, _dscMessageTypes.confManagementMessage);
	}
	else 
	{
		resetParticipantList()
		var prt = "";
		var prtName = "";
		var isLdr = false;
		var reqLdr = false;
		var prtList = msgRoot.getElementsByTagName("Participant");
		for (var prtInd = 0; prtInd < prtList.length; prtInd++) 
		{
			prt = prtList[prtInd];
			prtName = prt.attributes.getNamedItem('Name').value;
			isMe = prtName === _participant.ptName;
			isLdr = (prt.attributes.getNamedItem('Leader').value === "TRUE") ? true : false;
			isInitiator = (prt.attributes.getNamedItem('Creator').value === "TRUE") ? true : false;
			reqLdr = (prt.attributes.getNamedItem('Queue_Index').value === "-1") ? false : true;
			addParticipant(prtName, isLdr, isInitiator, isMe, reqLdr);
		}
	}
}

function addParticipant(prtName, isLeader, isInitiator, isMe, reqLeadership)
{

    var prtListNode = $("#prtListId");
    var nameText = prtName;
    if (isInitiator || isMe)    
    {
    	nameText += " (";
    	if (isInitiator)
    		nameText += 'host';
    	if (isInitiator && isMe)
    		nameText += ' ';
    	if (isMe)
    		nameText += 'me';
		nameText += ")";
    }

    var img = "";
    var requestLeadership = "";
    var title = "";
    var imgClass = "class='dscImg'";
    var giveControl = '';

    if (isMe)
    {
    	requestLeadership = "onclick='requestLeadership();'";
	}
 	if (isInitiator)
 	{
		requestLeadership = "onclick='grabLeadership();'";
		if (isMe)
		{
    		var inviteButton = $('#confInviteBtn');
    		inviteButton.css('visibility', 'visible');
		}
 	}

    if (isLeader)
    {
        img = "<img " + imgClass + " src='/images/leader.png'>";
 	}
    else if(reqLeadership)
    {
        if (_participant.isLeader)
        {
        	img = "<img " + imgClass + " src='/images/leader.png'/img>"
        	giveControl = "<a href='#' onclick=\"assignLeadership('" + prtName + "'); \"> Give Control</a>";
		}
        else
        {
        	img = "<img " + imgClass + " src='/images/requested.png' " + requestLeadership + ">";
		}
    }
    else
    {
    	if (_participant.isLeader)
    	{
    		if (isMe === false)
    		{
    			title = "title='Click to assign control to this user'";
    			imgClass = "class='dscImg cursorPointer'";
			}
       		img = "<img " + title + " " + imgClass + " src='/images/participant.png' onclick=\"assignLeadership('" + prtName + "'); \">";
		}
    	else
    	{
    		if (isMe)
    		{
    			if (isInitiator)
    				title = "title='Click to grab control'";
    			else
    				title = "title='Click to request control'";
    			imgClass = "class='dscImg cursorPointer'";
			}
       		img = "<img " + title + " " + imgClass + " src='/images/participant.png' " + requestLeadership + ">";
		}
	}
    prtListNode.append("<li>" + img + nameText + giveControl + "</li>");
}

function resetParticipantList() 
{
	var prtListNode = document.getElementById("prtListId");
	if (prtListNode)
    {
		prtListNode.innerHTML = "";
    }
}

function inviteParticipants()
{
	if (_participant.vilDivId !== "" && $('#' + _participant.vilDivId).is($.getVilInstance()))
	{
		$.getVilInstance().openConferenceInvite(_participant.confId, _participant.confName);
	}
}

/*
Leadership management functions
*/
function requestLeadership()
{
	var msgDoc = createXMLDocument("temp");

	var dataNd = msgDoc.createElement("Data"); 				//create Data node. No real data required here

	g_dscClient.sendDSCMessage("New Leadership Request", dataNd, _dscMessageTypes.confManagementMessage);
}

function assignLeadership(userName) 
{
	var newLdr = "Initiator";
    if (_participant.isLeader)
    {
        newLdr = userName;
    }

	var msgDoc = createXMLDocument("temp");

	var dataNd = msgDoc.createElement("Data"); 				//create Data node
	var newLdrNd = msgDoc.createElement("Name"); 			//create user Name node
	setXMLNodeText(newLdrNd, newLdr);
	dataNd.appendChild(newLdrNd);

	g_dscClient.sendDSCMessage("Assign Leadership", dataNd, _dscMessageTypes.confManagementMessage);
    return false;
}

function grabLeadership()
{
	var msgDoc = createXMLDocument("temp");

	var dataNd = msgDoc.createElement("Data"); 				//create Data node. No real data required here

	g_dscClient.sendDSCMessage("Grab Leadership", dataNd, _dscMessageTypes.confManagementMessage);
}

function sendUserMessage() 
{
	var msgDoc = createXMLDocument("temp");
	var dataNd = msgDoc.createElement("Data"); 									    //create Data node

	var usrMsgNode = msgDoc.createElement("UserMessage");
	setXMLNodeText(usrMsgNode, $('#outgoingChatBox').val());
	dataNd.appendChild(usrMsgNode);
    
    //set to "" to send to all, set to a specific username to send to one user
    var destUsr = "";
    

	var destUsrNode = msgDoc.createElement("SendTo");
	setXMLNodeText(destUsrNode, destUsr);
	dataNd.appendChild(destUsrNode);

	g_dscClient.sendDSCMessage("Multicast Data", dataNd, _dscMessageTypes.confManagementMessage);
	dscAddLineToChat("Me", $('#outgoingChatBox').val());
    $('#outgoingChatBox').val('');
}

function dscAddLineToChat(from, text)
{
	var newLine = IsIEDSC() ? '<br/>' : '\r\n';
	var chatBox = $('#confChatBox');
    chatBox.append(from + ": " + text + newLine);
	chatBox.scrollTop(chatBox[0].scrollHeight - chatBox.height());
}

function updateUserMsgList(msgRoot) 
{
	if (msgRoot) 
	{
		var txtMsg = getXMLNodeText(msgRoot, "UserMessage");
		var fromUsr = getXMLNodeText(msgRoot, "SentBy");

		dscAddLineToChat(fromUsr, $.trim(txtMsg));
	}
}

/*********************
* UI management functions
*********************/
function leadConference() 
{
	_participant.isLeader = true;

	document.getElementById("confFollower").attributes.getNamedItem("style").value = "visibility:hidden";
	document.getElementById("confGrabDiv").attributes.getNamedItem("style").value = "visibility:hidden";

}

function followConference() 
{
	_participant.isLeader = false;

	document.getElementById("confFollower").attributes.getNamedItem("style").value = "visibility:visible";
	if(_participant.createConf)
		document.getElementById("confGrabDiv").attributes.getNamedItem("style").value = "visibility:visible";

}

function resetConfControl() 
{
	document.getElementById("confControlDiv").attributes.getNamedItem("style").value = "visibility:hidden";
	document.getElementById("confFollower").attributes.getNamedItem("style").value = "visibility:hidden";
	document.getElementById("confGrabDiv").attributes.getNamedItem("style").value = "visibility:hidden";
}

/************
Generic DSC message utility functions
************/

function createXMLDocument(title) 
{
	var xmlDoc = null;
	try {	
		xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
		xmlDoc.async = false;
		dscMsgElem = xmlDoc.createElement(title)
		xmlDoc.documentElement = dscMsgElem;
	}
	catch (e) 
	{
		xmlDoc = document.implementation.createDocument("", title, null);
	}

	return xmlDoc;
}

var setXMLNodeText = (function () 
{
	var txtNodeName = createXMLDocument("temp").documentElement.text === undefined ? "textContent" : "text";
	return function (nd, txt) 
	{
		nd[txtNodeName] = txt;
		return nd;
	};
} ());

var getXMLNodeText = function (node, selector) {
	return $(node).find(selector).text();
};
